module.exports = __webpack_public_path__ + "static/media/中巴地球资源卫星04A星.c150fe52.png";